module.exports = __webpack_public_path__ + "static/media/turbo_cwu_on.6d0a0432.svg";